module.exports = __webpack_public_path__ + "img/logo-light.f5c9e054.png";